import { render, staticRenderFns } from "./DependencyEditor.vue?vue&type=template&id=9630888a&scoped=true"
import script from "./DependencyEditor.vue?vue&type=script&lang=js"
export * from "./DependencyEditor.vue?vue&type=script&lang=js"
import style0 from "./DependencyEditor.vue?vue&type=style&index=0&id=9630888a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9630888a",
  null
  
)

export default component.exports